import {
  CapacitySeatFill18Icon,
  FamilyFill18Icon,
} from "@vygruppen/spor-icon-react";
import { IncidentArrival } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/ActionableTrainGridItem/IncidentArrival";
import { MeasureDescription } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/ActionableTrainGridItem/MeasureDescription";
import { TrainIndicator } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/TrainIndicator";
import { getLabelForAltTransStation } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/utils";
import { AltTransIncidentTrain } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { TrainEventTypeEnum } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/types/trainEventTypeEnum";
import { FC } from "react";
import { HStack, Text, tokens } from "shared/components/Spor";
import styled, { useTheme } from "styled-components";

const TrainRouteWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: ${tokens.default.size.spacing[1]};
`;

type ExpandableHeaderProps = {
  actionableTrain: AltTransIncidentTrain;
};

export const ExpandableHeaderContent: FC<ExpandableHeaderProps> = ({
  actionableTrain,
}) => {
  const { originStop, destinationStop } = actionableTrain.trainRoute;
  const theme = useTheme();

  return (
    <>
      <TrainRouteWrapper>
        <TrainIndicator
          trainNumber={actionableTrain.id.id}
          incidentArrival={actionableTrain.incidentArrival}
        />
        <Text variant="sm" textAlign="left">
          {getLabelForAltTransStation(originStop)}–
          {getLabelForAltTransStation(destinationStop)}
        </Text>
      </TrainRouteWrapper>

      <HStack gap="1">
        <MeasureDescription
          measures={actionableTrain.measures}
          events={actionableTrain.events}
        />
      </HStack>

      <IncidentArrival incidentArrival={actionableTrain.incidentArrival} />

      <Text display="flex" alignItems="center" gap="0.5">
        <CapacitySeatFill18Icon />
        {actionableTrain.passengerCount.incidentStretchPassengerCount ??
          "Ukjent"}
        {actionableTrain.events.findIndex(
          (event) => event.type === TrainEventTypeEnum.TRAIN_GROUP_TRAVEL,
        ) !== -1 && <FamilyFill18Icon color={theme.colorAlarm} />}
      </Text>
    </>
  );
};
